export { default } from './GroupTableDesign';
